import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('LoyaltyNews').create(({ theme }) => ({
  root: {
    position: 'relative',
    width: '90%',
    cursor: 'pointer',
    height: '120px',
    background: 'black',
    borderRadius: theme.sizes.radiuses.l,

    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
      borderRadius: theme.sizes.radiuses.l,
    },
  },
}))
